import styled, { css } from 'styled-components';
import { Alert as AntAlert } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { AlertInterface, AlertProps } from './types';

const bodyBackground = (color: string) => (props: AlertProps) =>
  props.simple ? colors.gray0 : color;

export const StyledAlert = styled<AlertInterface>(AntAlert)`
  border-radius: 8px;
  border: unset;
  position: relative;
  overflow: hidden;
  padding: 16px 24px 16px 28px;

  ${props =>
    props.simple &&
    css`
      box-shadow:
        0px 2px 12px 0px #60617014,
        0px 0px 10px 0px #28293d0a,
        0px -1px 2px 0px #28293d08;
    `}

  &::before {
    content: '';
    width: 4px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  &.ant-alert-info {
    background: ${bodyBackground(colors.blue100)};

    &::before {
      background: ${colors.blue600};
    }

    & .ant-alert-icon {
      & svg {
        transform: rotate(180deg);

        & path:first-child {
          color: ${colors.blue600};
        }
      }
    }
  }

  &.ant-alert-success {
    background-color: ${bodyBackground(colors.green100)};

    &::before {
      background: ${colors.green600};
    }

    & .ant-alert-icon {
      & svg {
        & path:first-child {
          color: ${colors.green600};
        }
      }
    }
  }

  &.ant-alert-error {
    background-color: ${bodyBackground(colors.red100)};

    &::before {
      background: ${colors.red600};
    }

    & .ant-alert-icon {
      & svg {
        & path:first-child {
          color: ${colors.red600};
        }
      }
    }
  }

  &.ant-alert-warning {
    background-color: ${bodyBackground(colors.gold100)};

    &::before {
      background: ${colors.gold600};
    }

    & .ant-alert-icon {
      & svg {
        & path:first-child {
          color: ${colors.gold600};
        }
      }
    }
  }

  & .ant-alert-message {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: ${colors.gray900};

    ${props => !props.message && 'display: none'};
  }

  & .ant-alert-description {
    font-size: 14px;
    line-height: 24px;
    color: ${colors.gray900};

    ${props => !props.description && 'display: none'};
  }

  & .ant-alert-icon {
    display: flex;
    align-items: center;
    height: 24px;
    margin-right: 16px;

    ${props => props.message && props.description && 'align-self: flex-start'};

    & svg {
      width: 20px;
      height: 20px;

      & path:first-child {
        opacity: 1;
      }

      & path:nth-child(n + 2) {
        color: ${colors.gray0};
      }
    }
  }

  & .ant-alert-close-icon {
    margin-left: 16px;

    ${props => props.message && props.description && 'align-self: flex-start'};

    & .ant-alert-close-text {
      & svg {
        width: 20px;
        height: 20px;
        color: ${colors.gray650};
      }
    }
  }

  & .ant-alert-action {
    display: flex;
    gap: 8px;

    ${props => props.message && props.description && 'align-self: flex-start'};
  }

  &.ant-alert-with-description {
    & .ant-alert-message {
      margin-bottom: 8px;
    }
  }
`;
